import { render, staticRenderFns } from "./UserRightsCopierForm.vue?vue&type=template&id=4bb1f6ac&scoped=true"
import script from "./UserRightsCopierForm.vue?vue&type=script&lang=ts"
export * from "./UserRightsCopierForm.vue?vue&type=script&lang=ts"
import style0 from "./UserRightsCopierForm.vue?vue&type=style&index=0&id=4bb1f6ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1f6ac",
  null
  
)

export default component.exports